import {MaterialNode} from "#material/nodes/base/material/material-node"
import {ThreeColormassMaterial} from "#material/three/three-colormass-material"
import type {BsdfTransparentSockets} from "#material/nodes/shader/bsdf-transparent/definition"
import {bsdfTransparentDefinition} from "#material/nodes/shader/bsdf-transparent/definition"
import type {CyclesReturns} from "#material/sockets/cycles"
import {threeConvert, threeRGBColor} from "#material/three/three-utils"
import type {CyclesEvaluator, ThreeEvaluator} from "#material/nodes/base/material/types/evaluators"
import {registerMaterialGraphNode} from "#material/register"
import {cyclesColor} from "#material/cycles/helpers"
import type {ThreeReturns} from "#material/sockets/three"
import type {TransparentBsdfNode} from "#material/cycles/types"

@registerMaterialGraphNode
export class BsdfTransparent extends MaterialNode<BsdfTransparentSockets> {
    public override get definition() {
        return bsdfTransparentDefinition
    }

    override toThree = async (evaluator: ThreeEvaluator): Promise<ThreeReturns<BsdfTransparentSockets>> => {
        const material = new ThreeColormassMaterial()

        const {color} = await evaluator.getAll({
            color: this.parameters.inputs.color,
        })

        const opacityValue =
            color?.toColor() ??
            threeConvert(this.parameters.settings.color, threeRGBColor, (val) => val.r > 0.05 || val.g > 0.05 || val.b > 0.05) ??
            material.opacityNode

        if (opacityValue) {
            material.transparent = true
            material.opacityNode = opacityValue
        }

        return {bsdf: material}
    }

    override toCycles = async (evaluator: CyclesEvaluator): Promise<CyclesReturns<BsdfTransparentSockets>> => {
        const bsdf: TransparentBsdfNode = {
            type: "transparent_bsdf",
            inputs: {
                color: await evaluator.get(this.parameters.inputs.color),
                surface_mix_weight: undefined,
            },
            parameters: {color: cyclesColor(this.parameters.settings.color), surface_mix_weight: undefined},
            resources: {},
        }

        return {bsdf: [bsdf, "bsdf"]}
    }
}
